export const PROXY_SERVER_PORT = 5001;
export const TEMP_URL_DELIMITER = '__PTEMP__';

// The dev proxy encodes its upstream host into the path; recover it so callers can tell app.prophecy.io from .ai
export const getProxiedUpstreamHost = (url: string) =>
  url.match(new RegExp(`${TEMP_URL_DELIMITER}(.*?)${TEMP_URL_DELIMITER}`))?.[1];
